import * as types from './mutation-types'
import {cacheManager} from "@/services/cacheManagerjs";

export const loadAreas = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    cacheManager.fetch('get/areas/collection', state.areas)
        .then((response) => {
          if(!response.fromState) commit(types.ADD_AREAS, response.data)
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
  })
}

export const updateArea = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.patch('update/' + data.id + '/area', data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const createArea = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post('store/area', data).then((response) => {
      commit(types.ADD_AREA, response.data.data)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const deleteArea = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.delete('delete/' + id + '/area').then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

